import React, {useContext, useEffect, useState} from 'react';

import {useHttpClient} from '../../../../common/hook/http';
import {ContextAuth} from '../../../../common/context/context-auth';

import NoContent from '../../../../common/component/NoContent/NoContent';
import Loader from '../../../../common/component/Loader/Loader';
import Pagination from '../../../../common/component/Pagination/Pagination';
import ModalMicaCoinLottery from '../../../modal/MicaCoinLottery/MicaCoinLottery';

import {useWindowSize} from '../../../../common/hook/window-size';

import {Row, Col, Tabs, Tab, ListGroup} from 'react-bootstrap';

import './MicaCoinLottery.scss'

const MicaCoinLottery = () => {
    const {callAPI} = useHttpClient();
    const windowWidth = useWindowSize()[0]
    const auth = useContext(ContextAuth)

    // ------------------------------------------------------------------------------------------------------ fetch data

    const [pagination, setPagination] = useState(1)
    const [paginationDisabled, setPaginationDisabled] = useState(false)

    const [data, setData] = useState(null)

    const fetchData = async page => {

        setPaginationDisabled(true)

        try {
            const responseData = await callAPI(
                // برای بار اول از pagination استفاده می کند
                `crm/micaCoinLotteriesAndCodes/${Number.isInteger(page) ? page : pagination}`
            );

            if (responseData.message) {

            } else {

                Number.isInteger(page) && setPagination(page)
                setPaginationDisabled(false)

                setData(responseData.result)

            }

        } catch (e) {
            console.error(e);
        }

    }

    useEffect(() => {

        fetchData()

    }, [])

    // -----------------------------------------------------------------------------------------------------------------

    const [tab, setTab] = useState('tab1');

    const selectTabHandler = key => {

        if(key !== tab) setTab(key)

    }

    // -----------------------------------------------------------------------------------------------------------------

    const renderRatio = () => {

        if (windowWidth > 1199) return 'ratio-16x9'
        else if (windowWidth > 991 && windowWidth < 1200) return 'ratio-1x1'
        else if (windowWidth > 767 && windowWidth < 992) return 'ratio-16x9'
        else if (windowWidth > 575 && windowWidth < 768) return 'ratio-1x1'
        else return 'ratio-16x9'

    }

    // -----------------------------------------------------------------------------------------------------------------

    const [modalData, setModalData] = useState(null);
    const [modalMicaCoinLotteryShow, setModalMicaCoinLotteryShow] = useState(false);

    const modalMicaCoinLotteryShowHandler = item => {

        setModalData(item)

        setModalMicaCoinLotteryShow(true);

    }

    const modalMicaCoinLotteryHideHandler = response => {

        if (response) {

            setData(data => ({...data, ...response}))

            auth.editUser({...auth.user,
                availableCredit: response?.customer?.availableCredit,
                availablePoint: response?.customer?.availablePoint,
                availableTicket: response?.customer?.availableTicket,
            });

            setPagination(1)

            setTab('tab2')

        }

        setModalMicaCoinLotteryShow(false);

    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageAccountMicaCoinLottery" className={data?.lotteries?.length && Number(data?.totalPages) > 1 ? 'has-page-footer' : null}>
            {
                data ? (
                    <Tabs activeKey={tab} className="flex-nowrap hide-scrollbar mt-n2" justify onSelect={key => selectTabHandler(key)}>
                        <Tab eventKey="tab1" title="فهرست قرعه کشی ها" tabClassName="justify-content-center" className="pt-4">
                            {
                                data.lotteries.length ? (
                                    <Row className="gx-3 gy-4">
                                        {
                                            data.lotteries.map((item, index) => {
                                                return (
                                                    <Col sm={6} className="d-flex flex-column" key={index}>
                                                        <div className={`bg-primary ratio ${renderRatio()}`} role="button" onClick={() => modalMicaCoinLotteryShowHandler(item)}>
                                                            <span className="p-4 d-flex flex-column justify-content-end align-items-start text-accent">
                                                                <span className="fs-5 mb-1">از <span className="ltr d-inline-block px-1">{item.startShamsi}</span> تا <span className="ltr d-inline-block px-1">{item.endShamsi}</span></span>
                                                                <span className="h3 fw-bold mb-sm-3">{item.title}</span>
                                                                <button type="button" className="btn btn-outline-accent d-none d-sm-inline-flex">مشاهده</button>
                                                            </span>
                                                        </div>
                                                    </Col>
                                                )
                                            })
                                        }
                                        <ModalMicaCoinLottery show={modalMicaCoinLotteryShow} onHide={response => modalMicaCoinLotteryHideHandler(response)} data={modalData}/>
                                    </Row>
                                ) : (
                                    <div className="py-5">
                                        <div className="py-5">
                                            <NoContent text={`تخفیفی وجود ندارد`}/>
                                        </div>
                                    </div>
                                )
                            }
                        </Tab>
                        <Tab eventKey="tab2" title="قرعه کشی های شرکت کرده" tabClassName="justify-content-center" className="pt-4">
                            {
                                data.lotteryCodes.length ? (
                                    <>
                                        <ListGroup as="ul" variant="flush" className="my-n2">
                                            {
                                                data.lotteryCodes.map((item, index) => {
                                                    return (
                                                        <ListGroup.Item as="li" className="px-0 d-flex align-items-center border-bottom-0" key={index}>
                                                            <div className="me-auto">
                                                                <div className="fw-500 fs-18px">
                                                                    {item.lotteryTitle}
                                                                </div>
                                                                <div className="mb-1 text-primary d-flex align-items-center flex-wrap">
                                                                    <span className="text-nowrap pe-2">دریافت {item.created_at}</span><span className="text-nowrap">تاریخ قرعه کشی {item.lotteryDate}</span>
                                                                </div>
                                                                <div>{item.used_mica_coin} کوین کسر شده</div>
                                                            </div>
                                                            <div className="font-en ls-1 fs-18px fw-bold">{item.code}</div>
                                                        </ListGroup.Item>
                                                    )
                                                })
                                            }
                                        </ListGroup>
                                        {
                                            data.totalPages > 1 && (
                                                <div className="py-2 py-md-0 bg-body page-footer">
                                                    <Pagination pagination={pagination} paginationDisabled={paginationDisabled} totalPages={data.totalPages} onClick={res => fetchData(res)}/>
                                                </div>
                                            )
                                        }
                                    </>
                                ) : (
                                    <div className="py-5">
                                        <div className="py-5">
                                            <NoContent text={`قرعه کشی شرکت نکرده اید`}/>
                                        </div>
                                    </div>
                                )
                            }
                        </Tab>
                    </Tabs>
                ) : (
                    <div className="py-5 my-5">
                        <Loader text="در حال دریافت اطلاعات"/>
                    </div>
                )
            }
        </div>
    )
}

export default MicaCoinLottery;